import { Dialog, Kbd } from '@/components/ui'
import { HOTKEYS, prettyKeys } from '@/lib/hotkeys'
import { useHelp } from '@/stores/help'

/** Shift+? lists the keyboard shortcuts. */
export function HelpSheet() {
  const { help, setHelp } = useHelp()
  const groups = [...new Set(HOTKEYS.map((h) => h.group))]
  return (
    <Dialog open={help} onOpenChange={setHelp} title="Keyboard shortcuts" width={520}>
      <div className="grid grid-cols-2 gap-x-6 gap-y-4">
        {groups.map((g) => (
          <div key={g}>
            <div className="mb-1 text-xs text-fg-subtle">{g}</div>
            {HOTKEYS.filter((h) => h.group === g).map((h) => (
              <div key={h.keys} className="flex h-7 items-center justify-between text-xs">
                <span className="text-fg-muted">{h.label}</span>
                <Kbd>{prettyKeys(h.keys)}</Kbd>
              </div>
            ))}
          </div>
        ))}
      </div>
    </Dialog>
  )
}
